import { Loading } from 'components/controls/loading'
import { ErrorBlock } from 'components/controls/errorInfo'

import { Box, BoxProps, FormControl, Select, MenuItem } from '@mui/material'

import { useListBlock } from 'interface/prefecture'

type BlockFormProps = {
  defaultBlockCode: string
  onSelectedBlock: (code: string) => void
} & BoxProps
export const BlockForm = ({
  defaultBlockCode,
  onSelectedBlock,
  ...others
}: BlockFormProps) => {
  const blockState = useListBlock()
  return (
    <Box paddingX={1} {...others}>
      <FormControl fullWidth>
        {blockState.loading && <Loading />}
        <ErrorBlock error={blockState.error} padding={1}/>
        {blockState.data ? (
          <Select
            fullWidth
            id="block"
            defaultValue={defaultBlockCode}
            onChange={(event) => onSelectedBlock(event.target.value)}
            size="small"
          >
            <MenuItem key="all" value="all">
              全国
            </MenuItem>
            {(blockState.data.list ?? []).map((block) => (
              <MenuItem key={block.blockCode} value={block.blockCode}>
                {block.blockName}
              </MenuItem>
            ))}
            ;
          </Select>
        ) : (
          <></>
        )}
      </FormControl>
    </Box>
  )
}
